module.exports = __webpack_public_path__ + "img/czzsnew.3c702b23.gif";